import { QuoteListApp } from "document/list/app";
import { DocumentTotalsApp } from "documenttotals/DocumentTotalsApp";
import DocumentV1CopyApp from "documentV1/copy/App";
import DocumentV1DetailApp from "documentV1/detail/App";
import DocumentV1NewApp from "documentV1/new/App";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const quoteRoute: RouteObject = {
  children: [{
    index: true,
    path: "quote",
    loader: () => viewModel,
    Component: QuoteListApp,
  }, {
    path: "quote/total",
    loader: () => ({ viewModel, documentType: "quote" }),
    Component: DocumentTotalsApp,
  }, {
    path: "quote/new",
    loader: () => viewModel,
    Component: DocumentV1NewApp,
  }, {
    path: "quote/detail/:documentId",
    loader: () => viewModel,
    Component: DocumentV1DetailApp,
  }, {
    path: "quote/copy/:documentId",
    loader: () => viewModel,
    Component: DocumentV1CopyApp,
  }]
};